const translations = {
  'sform.title': '¡Suscríbete a nuestra newsletter!',
  'sform.description':
    'Recibe actualizaciones de cursos, reseñas de graduados, descuentos exclusivos y más.',
  'sform.name.placeholder': 'Tu nombre',
  'sform.email.placeholder': 'Tu email',
  'sform.signUpNow': '¡Regístrate ahora!',
};

export default translations;
